/** Default page size for GET /ai-visibility-report/:projectId/reports (mirrors llm-common). */
export const AI_VISIBILITY_REPORTS_DEFAULT_PAGE_SIZE = 20;
